import React from 'react';

const ProgressCircle = React.createClass({
    render() {
        let progress = this.props.progress;
        const step = this.props.progressType;

        if(step) {
            if(progress > 0 && progress < 100) {
                progress = 50;
            }
        }

        const label = this.props.label;
        const size = this.props.size;

        const borderSize = this.props.border || 2;
        const radius = (size / 2) - borderSize
        const circumference = 2 * Math.PI * radius;
        const circleProgress = circumference - ((circumference / 100) * progress);

        return (
            <div
                className={`progress-circle-wrap ${progress == '100' ? 'full' : ''}`}
                style={{width: size, height: size}}
            >
                <svg
                    style={{width: size, height: size}}
                    className="progress-circle"
                >
                    <circle
                        className="progress-circle-back"
                        r={radius}
                        cx={radius + borderSize}
                        cy={radius + borderSize}
                        style={{
                            strokeWidth: borderSize
                        }}
                    />
                    <circle
                        className="progress-circle-front"
                        r={radius}
                        cx={radius + borderSize}
                        cy={radius + borderSize}
                        style={{
                            strokeWidth: borderSize,
                            strokeDashoffset: circleProgress,
                            strokeDasharray: circumference
                        }}
                    />
                </svg>
                {label && <span className="progress-circle-label">{label}</span>}
            </div>
        );
    }
});

export default ProgressCircle;


/** WEBPACK FOOTER **
 ** ./src/components/ProgressCircle/ProgressCircle.js
 **/